'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectStyles = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _lodash = require('lodash');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _constants = require('../../constants');
var _sharedStyles = require('../shared-styles');
var _selectArrows = require('../../../assets/select-arrows.png');
var _selectArrows2 = _interopRequireDefault(_selectArrows);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var selectStyles = exports.selectStyles = function selectStyles(props) {
  var theme = props.theme;
  var validationStyles = {};
  if (typeof props.valid !== 'undefined') {
    validationStyles = props.valid ? (0, _sharedStyles.validStyles)(theme) : (0, _sharedStyles.invalidStyles)(theme);
  }
  return Object.assign({}, (0, _sharedStyles.formControl)(theme), {
    backgroundImage: 'url(' + _selectArrows2.default + ')',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 1rem center',
    padding: '.6rem 2.5rem .6rem 1rem',
    '::-ms-expand': {
      display: 'none'
    }
  }, validationStyles);
};
var SelectComponent = (0, _glamorous2.default)('select')(selectStyles);
var Select = function (_Component) {
  _inherits(Select, _Component);
  function Select() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Select);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
      _this.props.onChange(e.target.value);
    }, _this.renderOptions = function () {
      var options = [];
      if (_this.props.placeholder) {
        options.push(_react2.default.createElement('option', {
          value: '',
          key: 'placeholder'
        }, _this.props.placeholder));
      }
      _this.props.options.map(function (option) {
        var value = typeof option === 'string' ? option : option.value;
        var text = typeof option === 'string' ? option : option.text;
        return options.push(_react2.default.createElement('option', {
          value: value,
          key: value
        }, text));
      });
      return options;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Select, [{
    key: 'render',
    value: function render() {
      /* eslint-disable jsx-a11y/no-onchange */
      return _react2.default.createElement(SelectComponent, Object.assign({}, (0, _lodash.omit)(this.props, _constants.omitProps), {
        onChange: this.handleChange
      }), this.renderOptions());
    }
  }]);
  return Select;
}(_react.Component);
Select.propTypes = {
  placeholder: _propTypes.string,
  options: _constants.optionsPropTypes,
  size: _propTypes.number,
  multiple: _propTypes.bool,
  onChange: _propTypes.func.isRequired
};
Select.defaultProps = {
  options: [],
  value: '',
  placeholder: undefined
};
exports.default = Select;